module.exports = [
  { 'id': 'nanjing', 'text': '南京' },
  { 'id': 'beijing', 'text': '北京' },
  { 'id': 'guangzhou', 'text': '广州' },
  { 'id': 'shenzhen', 'text': '深圳' },
  { 'id': 'chengdu', 'text': '成都' },
  { 'id': 'chongqing', 'text': '重庆' },
  { 'id': 'shanghai', 'text': '上海' }
];




/** WEBPACK FOOTER **
 ** ./docs/src/js/data/text-value.js
 **/